module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado9.77dd9107.svg";